import type IJourneyPage from '@/mixins/IJourneyPage'
import type ITransitionAction from '@/page-transitions/transition-actions/ITransitionAction'
import type ProductEnum from '@/services/enums/ProductEnum'
import type { PageNavigationConfig } from '@/view-models/PageNavigationConfig'
import Routes from '@/constants/Routes'
import ContextLevel from '@/services/enums/ContextLevel'
import BadRequestError from '@/services/error/BadRequestError'
import { RatingStatus } from '@/services/values/RatingResponse'
import useAggregatorStore from '@/stores/aggregator-store'
import useAnswersStore from '@/stores/answers-store'

export default class GetQuoteAction implements ITransitionAction {
  canExecute(currentContext: ContextLevel, nextContext: ContextLevel): boolean {
    return currentContext === ContextLevel.preQuote && nextContext === ContextLevel.quote
  }

  async execute(page: IJourneyPage): Promise<PageNavigationConfig | null> {
    page.$events.emit('set-loading-text', 'Getting you a price...')
    page.isLoading = true

    const answersStore = useAnswersStore()
    const aggregatorStore = useAggregatorStore()

    const currentAnswers = answersStore.answers
    const { product } = page.$route.params
    try {
      const ratingResponse = await page.$services.ratingEngineService.getQuote(currentAnswers, aggregatorStore.aggregatorQuoteReference?.quoteReference ?? null, product as ProductEnum, page.$route.query)
      if (ratingResponse.status === RatingStatus.quoted) {
        page.isLoading = false
        return {
          params: {
            quoteReference: ratingResponse.quoteReference!,
          },
        }
      }
      page.$router.push({
        name: Routes.quoteDeclined,
        params: {
          quoteReference: ratingResponse.quoteReference ?? '',
        },
      })
      page.isLoading = false
    }
    catch (e) {
      if (e instanceof BadRequestError) {
        page.$buefy.toast.open({
          duration: 5000,
          message: (Object.values(e.modelState!)[0]) ?? e.message,
          type: 'is-danger',
          position: 'is-bottom',
        })
      }
      else {
        throw e
      }
    }
    return null
  }
}
